
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","width":"28","height":"28","viewBox":"0 0 28 28"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"14","cy":"14","r":"14","fill":"#CFF2D0"}}),_c('path',{attrs:{"fill":"#008009","d":"M3.762 16.217H7.88v4.07h2.125v-4.07h4.117v-2.125h-4.118v-4.07H7.88v4.07H3.762v2.125zM20.1 20.625h2.425V7.062H20.11l-3.544 2.49v2.285l3.374-2.388h.16v11.176z"}})])
          )
        }
      }
    